import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConsoleLogAppender, LoggerFactory, LogLevel, SimpleMessageFormatter } from '@elderbyte/ts-logger';
import { environment } from '../environments/environment';
import { AutoLogoutService } from './shared/providers/auto-logout.service';
import * as moment from 'moment';


@Component({
  selector: 'tcc-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(private translate: TranslateService, private autoLogoutService: AutoLogoutService) {

    // Set moment.js default language & default invalid date message
    moment.updateLocale('de', {
      invalidDate: '-',
      nullInput: '-',
      empty: '-',
    });

    this.translate.addLangs(['de', 'en']);

    // Set fallback language
    this.translate.setDefaultLang('de');

    // Set used language
    this.translate.use('de');

    // Configure logger
    LoggerFactory.getDefaultConfiguration()
      .withMaxLevel(environment.production ? LogLevel.Info : LogLevel.Trace) // Defaults to Info
      .withAppender(new ConsoleLogAppender()) // Same as default
      .withFormatter(new SimpleMessageFormatter()); // Same as default
  }

}
